import styled from "styled-components";

export const Container = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  background: var(--fixit);
  color: var(--white);
  font-size: 14px;
  font-weight: 600;
  padding: 8px 16px;
  border-radius: 20px;
  border: 1px solid var(--fixit);
  cursor: pointer;
  transition: background-color 0.2s ease-in-out;
  
  /* Match the visual height of DropdownFilter */
  height: 38px;
  box-sizing: border-box;

  &:hover {
    background: var(--fixit-hover);
    border-color: var(--fixit-hover);
  }

  svg {
    stroke-width: 2.5px;
    color: var(--white);
  }

  &:disabled {
    background: var(--light-gray);
    border-color: var(--light-gray);
    cursor: not-allowed;
  }

  .loading {
    border: 2px solid rgba(255, 255, 255, 0.3);
    border-top: 2px solid var(--white);
    border-radius: 50%;
    width: 18px;
    height: 18px;
    animation: spin 0.6s linear infinite;
  }

  @keyframes spin {
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
  }
`;
